import { Icon } from '@zambezi/sdk/icons';
import classNames from 'classnames';
import Column from 'components/Column';
import Columns from 'components/Columns';
import { useState } from 'react';
import './CollapsibleCard.scss';

export interface CollapsibleCardProps {
  children: React.ReactNode | React.ReactNode[];
  id: string;
  title: string;
  secondaryTitle?: string;
  isClosed?: boolean;
}

const CollapsibleCard = ({
  children,
  id,
  title,
  secondaryTitle,
  isClosed = false
}: CollapsibleCardProps) => {
  const [open, setOpen] = useState(!isClosed);

  const columnSize = secondaryTitle ? 6 : 12;

  const handleClick = () => setOpen(!open);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <>
      <div className="zb-card">
        <header
          id={`${id}-header`}
          className={classNames('zb-card-header', 'collapsible-card-header', {
            'collapsible-card-header-closed': !open
          })}
          tabIndex={0}
          role="button"
          aria-expanded={open}
          aria-controls={`${id}-body`}
          onClick={handleClick}
          onKeyDown={handleKeyDown}
        >
          <Columns className="collapsible-card-heading">
            <Column
              mobile={columnSize}
              tablet={columnSize}
              desktop={columnSize}
              widescreen={columnSize}
            >
              <h2 className="zb-card-header-title">{title}</h2>
            </Column>
            {secondaryTitle && (
              <Column
                mobile={columnSize}
                tablet={columnSize}
                desktop={columnSize}
                widescreen={columnSize}
              >
                <h2 className="zb-card-header-title">{secondaryTitle}</h2>
              </Column>
            )}
          </Columns>
          <Icon
            name={open ? 'core-accordion-collapse' : 'core-accordion-expand'}
            aria-hidden
            title={open ? 'Collapse' : 'Expand'}
          />
        </header>
        <div className="collapsible-card-content">
          {open && <div className="collapsible-card-body zb-card-body">{children}</div>}
        </div>
      </div>
    </>
  );
};

export default CollapsibleCard;
